import React, {Component} from 'react';

import ga from '../../../vendor/google-analytics';

export class VideoPlayerSocialEmbedBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: props.width,
      height: props.height
    }
  }

  trackCopyEvent(event) {
    ga('send', 'event', 'social', this.props.gaAction, window.location.href);
  }

  updateWidth(event) {
    let width = parseInt(event.currentTarget.value.replace(/[^0-9]/, '')) || '';
    let height = width && Math.floor(width * 9/16) || 0;
    this.setState({width, height});
  }

  updateHeight(event) {
    let height = parseInt(event.currentTarget.value.replace(/[^0-9]/, '')) || '';
    let width = height && Math.floor(height * 16/9) || 0;
    this.setState({width, height});
  }

  embedString(tpMediaId) {
    let {width, height} = this.state;
    return `<iframe width="${width}" height="${height}" src="https://player.pbs.org/viralplayer/${tpMediaId}/" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" seamless allowfullscreen></iframe>`;
  }

  render() {
    return <div className="embed-wrapper">
      <div className="ui-widget-overlay ui-front embed-overlay"></div>
      <div className="embed embed-page">
        <div className="embed-close">
          <span className="ui-dialog-title">&nbsp;</span>
          <button className="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close" aria-label="close" title="Close" onClick={this.props.onClose}>
            <span className="ui-button-icon-primary ui-icon ui-icon-closethick"></span>
            <span className="ui-button-text">Close</span>
          </button>
        </div>
        <div className="embed-title headline-section">
          Embed
        </div>
        <label className="embed-label" htmlFor="embed-width-control">WIDTH</label>
        <input id="embed-width-control" className="embed-control embed-width-control" type="text" value={this.state.width} onChange={this.updateWidth.bind(this)}/>
        <label className="embed-label" htmlFor="embed-height-control">HEIGHT</label>
        <input id="embed-height-control" className="embed-control embed-height-control" type="text" value={this.state.height} onChange={this.updateHeight.bind(this)}/>
        <textarea className="embed-code" readOnly="readonly" data-tp-media-object-id={this.props.tpMediaId} value={this.embedString(this.props.tpMediaId)} onCopy={this.trackCopyEvent.bind(this)}></textarea>
        <div>
          To embed this video, copy and paste the code above.
        </div>
      </div>
    </div>;
  }
}

export default VideoPlayerSocialEmbedBox;